import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/business`;

export default {
  async detail() {
    let apiUrl = store.state.countrySelected.api;
    let params = {
      lang: store.state.langSelected.langWsp
    };
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/detail`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        statuscode: error.status,
        error: true
      };
    }
  },
  async contact(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/contact?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async checkPendingContact() {
    let apiUrl = store.state.countrySelected.api;
    let params = {
      lang: store.state.langSelected.langWsp
    };
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/hasPendingContact`, {
        params: params
      });

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        statuscode: error.status,
        error: true
      };
    }
  }
};
